import { render, staticRenderFns } from "./StatsSc.vue?vue&type=template&id=8687c476&scoped=true&"
import script from "./StatsSc.vue?vue&type=script&lang=js&"
export * from "./StatsSc.vue?vue&type=script&lang=js&"
import style0 from "./StatsSc.vue?vue&type=style&index=0&id=8687c476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8687c476",
  null
  
)

export default component.exports